import T from '../types';

export default (query = '') => ({
  type: T.SET_DEPARTURE_QUERY,
  query,
});
